// dependencies
import { List, Map } from "immutable";
import moment from "moment";

// selectors
import { getPageUI } from "../../../../../selectors/page";

export const getLocalState = (state) => getPageUI(state);

export const getCopyCycleID = (state) => state.navigation.getIn(["page", "query", "copyCycleId"], null);

export const getHasInitialized = (state) => {
	const local = getLocalState(state);
	return local.getIn(["initialized"], false);
};

/** Get the selected template id */
export const getReviewTemplateID = (state, notSetValue = null) => {
	const local = getLocalState(state);
	return local.getIn(["inputs", "template", "id"], notSetValue);
};

/** Get the start date time input value */
export const getStartDateTime = (state, notSetValue = null) => {
	const local = getLocalState(state);
	return local.getIn(["inputs", "startdate"], notSetValue);
};

export const getGroupID = (state, notSetValue = null) => {
	const local = getLocalState(state);
	return local.getIn(["inputs", "grouppicker", "id"], notSetValue);
};

/** Get the list of review template forms. */
export const getReviewTemplateForms = (state) => getLocalState(state).get("templateForms", List());

/** Get the list of review template forms by type. */
export const getLocalFormsByType = (state, formType) =>
	getLocalState(state)
		.get("templateForms", List())
		.filter((form) => form.get("type") === formType);

/** Get a list of form indexes the user is currently editing. */
export const getEditingForms = (state) => getLocalState(state).get("editingForms", List());

/**
 * Collect the data from the state and create the payload to send to the server
 */
export const getCyclePayload = (state) => {
	const local = getLocalState(state);
	const templateForms = getReviewTemplateForms(state).map((form) => {
		const updates = form.get("assignment", Map());

		// convert moments to iso strings
		const mutatedUpdates = updates.withMutations((mutable) => {
			if (mutable.has("authorsDueDate")) {
				const authorsDueDate = mutable.get("authorsDueDate");
				mutable.set("authorsDueDate", authorsDueDate ? authorsDueDate.toISOString() : null);
			}

			if (mutable.has("signersDueDate")) {
				const signersDueDate = mutable.get("signersDueDate");
				mutable.set("signersDueDate", signersDueDate ? signersDueDate.toISOString() : null);
			}

			if (mutable.has("authors")) {
				mutable.set(
					"authors",
					mutable.get("authors", List()).map((employee) => employee.get("id"))
				);
			}

			if (mutable.has("signers")) {
				mutable.set(
					"signers",
					mutable.get("signers", List()).map((employee) => employee.get("id"))
				);
			}
		});

		const formObject = {
			assignment: mutatedUpdates,
			type: form.getIn(["type"], null),
			formID: form.getIn(["form", "id"], null),
		};

		return formObject;
	});

	const payload = {
		assignments: templateForms.toJS(),
		cycleName: local.getIn(["inputs", "cyclename"], ""),
		template: local.getIn(["inputs", "template", "id"], null),
		startDate: local.getIn(["inputs", "startdate"], null),
		adminEdit: local.getIn(["inputs", "adminedit"], null),
		group: local.getIn(["inputs", "grouppicker", "id"], null),
	};

	if (moment.isMoment(payload.startDate)) {
		payload.startDate = payload.startDate.toISOString();
	}

	return payload;
};
